import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useDeliveryRatesLogic from "./useDeliveryRatesLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "address", label: "Address", allowSorting: true },
  {
    field: "season",
    label: "Season",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  {
    field: "currency",
    label: "Currency",
    allowSorting: true,
    subvalue: "code",
    showInFilter: true,
  },
  { field: "rate", label: "Daily rate", allowSorting: true },
];

const DeliveryRatesPage = () => {
  const { addRoles, deleteRoles, editRoles, initFields, apiRoute } =
    useDeliveryRatesLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(
          config,
          "seasons",
          "season",
          temp,
          "Name",
          "branch"
        ),
        fetchDataAndMapToField(
          config,
          "currencies",
          "currency",
          temp,
          "code",
          "symbol"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Delivery Rates" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"delivery_rates"}
        apiRoute={apiRoute}
        bringFormData={loadOptions}
        columns={columns}
        fields={fields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "season", lookupTable: "season", lookupField: "Name" },
            { field: "currency", lookupTable: "currency", lookupField: "code" }
          ]
        }}
      />
    </div>
  );
};

export default DeliveryRatesPage;
